export const AUTOMATION_IDS = {
  RESIZE_HANDLE_CONTAINER: 'site-segment-resize-handle-container',
  EMPTY_STATE: {
    CONTAINER: 'site-segment-empty-state',
    ADD_ELEMENT: 'site-segment-empty-state-add-element',
  },
};
